// One event's Sales Access: its switch, its tickets with theirs, its sales (docs/SALES-ACCESS.md).
// ?category= opens that ticket's drawer once.
import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SalesAccessEventRoute } from '../modules/venue-port/tkt/SalesAccessRoutes';

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);

export const Route = createFileRoute('/sales-access/event/$eventId')({
  validateSearch: (s: Record<string, unknown>): { category?: string } => ({ category: str(s.category) }),
  component: function SalesAccessEvent() {
    const { eventId } = Route.useParams();
    const { category } = Route.useSearch();
    return <SalesAccessEventRoute eventId={eventId} categoryId={category} />;
  },
});
